'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionDocuments', ['$scope', function ($scope) {
        $scope.resetInspection();
        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.inspecting.inspection.document',
                    params: [
                        {
                            name: 'inspectionDocumentID',
                            field: 'id'
                        },
                        {
                            name: 'inspection_document',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Type',
                field: 'document_type.name'
            },
            {
                label: 'File',
                field: 'file_name'
            },
            {
                label: 'Created On',
                field: 'createdon',
                type: 'date'
            },
            {
                label: 'Created By',
                field: 'createdby'
            }
        ];

        $scope.filters = [
            {
                name: 'Document Type',
                field: 'document_type_id',
                service: 'DocumentTypes'
            }
        ];
    }])
;